import { capitalApi } from '../api';

export const capitalRepo = {
    getAll: (params) => capitalApi.getAll(params),
    getById: (capitalId) => capitalApi.getById(capitalId),
    getByShop: (shopId) => capitalApi.getByShop(shopId),
    getAllByShop: (shopId, params) => capitalApi.getAllByShop(shopId, params),
    getTotalByShop: (shopId) => capitalApi.getTotalByShop(shopId),
    getByDateRange: (params) => capitalApi.getByDateRange(params),
    create: (data) => capitalApi.create(data),
    update: (capitalId, data) => capitalApi.update(capitalId, data),
    toggleStatus: (capitalId) => capitalApi.toggleStatus(capitalId),
    delete: (capitalId) => capitalApi.delete(capitalId),
};